import { AlertUtil } from './../utils/alert-util';
import { Component, OnInit, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IRichiesta } from '../interfaces/IRichiesta';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { RichiestaService } from '../services/richiesta.service';
import { finalize } from 'rxjs/operators';
import { IDocumento } from '../interfaces/IDocumento';
import { ICommessa } from '../interfaces/ICommessa';
import { DialogService } from 'primeng/api';
import { NoteModalComponent } from '../note-modal/note-modal.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-send-richiesta-modal',
  templateUrl: './send-richiesta-modal.component.html',
  styleUrls: ['./send-richiesta-modal.component.css']
})
export class SendRichiestaModalComponent implements OnInit {
  @ViewChild('op') op: OverlayPanel
  isValid: boolean = false
  isAffidatario: boolean = false
  commessa: ICommessa
  richiestaSelected: IRichiesta //richiesta selected
  documenti: IDocumento[]
  SE = Enum.REQUEST_STATE_NAME_ENUM   //export for html

  constructor(private config: DynamicDialogConfig, private ref: DynamicDialogRef,
    private alertUtil: AlertUtil, private richiestaService: RichiestaService, private dialogService: DialogService, private translate: TranslateService) {
    //from component
    this.commessa = this.config.data.commessa
    this.richiestaSelected = this.config.data.richiesta
    this.documenti = this.config.data.documenti
    this.isValid = this.richiestaSelected.StatoRichiesta.Id == Enum.REQUEST_STATE_ENUM.APPROVATO
    this.isAffidatario = this.config.data.isAffidatario
  }

  ngOnInit() {
  }

  /**
  * Send richiesta to Prefettura
  */
  sendRichiestaToPrefettura() {
    this.alertUtil.showConfirmationAlert("LBL_RICHIESTA_SEND_TO_CONFIRMATION", null, null, null, null, () => {
      // set StatoRichiesta to APPROVATO
      this.richiestaSelected.StatoRichiesta.Id = Enum.REQUEST_STATE_ENUM.APPROVATO
      this.richiestaSelected.StatoRichiesta.Nome = Enum.REQUEST_STATE_NAME_ENUM.APPROVATO

      //save richiesta
      Loading.isLoading = true
      let reqBuilderPath = this.richiestaSelected.Cantiere ? ['Cantiere', 'TipoContratto', 'StatoRichiesta'] : ['TipoContratto', 'StatoRichiesta', 'Commessa']
      let reqBuilder = new RequestBuilder(this.richiestaSelected, reqBuilderPath)
      this.richiestaService.changeStatusRichiesta(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            this.alertUtil.showAlert("LBL_RICHIESTA_SENT_TO_PREFETTURA", null, null, null, () => {
              //force refresh richieste table
              this.ref.close(this.richiestaSelected)
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log("ERROR: " + response.error.Stack)
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }


  /**
   * Send richiesta to Aggiudicatario
   * set StatoRichiesta to BOZZA
   */
  sendRichiestaToAggiudicatario() {
    // Controllo se tutti i doc da inviare sono validi; se non è così apro modale per Nota validazione
    let allValid: boolean = true

    for (const doc of this.documenti) {
      if (doc.Valido != null && !doc.Valido) {
        allValid = false;
        break;
      }
    }
    // Se sono Staz. App. e il documento non è valido, apro modale per specifica nota non validazione.
    if (this.isAffidatario && !allValid) {
      this.openNotaValidazioneModal()
    } else {
      this.alertUtil.showConfirmationAlert("LBL_RICHIESTA_SEND_TO_CONFIRMATION", null, null, null, null, () => {
        this.callChangeRichiestaStatus()
      })
    }
  }


  /**
   * Apri modale per inserimento nota validazione
   */
  openNotaValidazioneModal() {

    this.translate.get(["LBL_NOTA_RIFIUTO"]).subscribe(res => {
      this.ref.close(this.richiestaSelected)
      //open send richiesta modal
      let noteModal = this.dialogService.open(NoteModalComponent, {
        data: { richiesta: this.richiestaSelected },
        header: res["LBL_NOTA_RIFIUTO"],
        width: '40%'
      })

      noteModal.onClose.subscribe((notaValidazione: string) => {
        //se nota validazione è stata inviata allora cambia lo stato della richiesta e invia la nota
        if (notaValidazione) {
          this.richiestaSelected.NotaValidazione = notaValidazione
          this.callChangeRichiestaStatus()
        }
      })
    })



  }


  /**
   * Costruisci reqBuilder e chiama API: 'richiesta/changeStatus'
   */
  callChangeRichiestaStatus() {
    this.changeRichiestaStatus();
    //save richiesta
    Loading.isLoading = true
    let reqBuilderPath = this.richiestaSelected.Cantiere ? ['Cantiere', 'TipoContratto', 'StatoRichiesta'] : ['TipoContratto', 'StatoRichiesta', 'Commessa']
    let reqBuilder = new RequestBuilder(this.richiestaSelected, reqBuilderPath)
    this.richiestaService.changeStatusRichiesta(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_RICHIESTA_SENT_TO_AGGIUDICATARIO", null, null, null, () => {
            //force refresh richieste table
            this.ref.close(this.richiestaSelected)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

  /**
   * change richiesta status
   * @param statoRichiesta richiesta enum
   */
  private changeRichiestaStatus(statoRichiesta?: Enum.REQUEST_STATE_NAME_ENUM) {
    if (!statoRichiesta) {
      let allDocsValid: boolean = true
      //check status of request iterating over docs
      this.documenti.forEach(doc => {
        let docValid: boolean = doc.Valido ? true : false
        allDocsValid = allDocsValid && docValid
      });
      //set statoRichiestas
      statoRichiesta = allDocsValid ? Enum.REQUEST_STATE_NAME_ENUM.APPROVATO : Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO
    }

    if (statoRichiesta == Enum.REQUEST_STATE_NAME_ENUM.APPROVATO) {
      // set StatoRichiesta to APPROVATO
      this.richiestaSelected.StatoRichiesta.Id = Enum.REQUEST_STATE_ENUM.APPROVATO;
      this.richiestaSelected.StatoRichiesta.Nome = Enum.REQUEST_STATE_NAME_ENUM.APPROVATO;
    }
    else if (statoRichiesta == Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO) {
      // set StatoRichiesta to NON_VALIDO
      this.richiestaSelected.StatoRichiesta.Id = Enum.REQUEST_STATE_ENUM.NON_VALIDO;
      this.richiestaSelected.StatoRichiesta.Nome = Enum.REQUEST_STATE_NAME_ENUM.NON_VALIDO;
    }
    else {
      // set StatoRichiesta to BOZZA
      this.richiestaSelected.StatoRichiesta.Id = Enum.REQUEST_STATE_ENUM.BOZZA;
      this.richiestaSelected.StatoRichiesta.Nome = Enum.REQUEST_STATE_NAME_ENUM.BOZZA;
    }
  }
}
